import React, { useState } from "react";
import Login from '../components/Authentication/Login';

export default function SignIn() {

  return (
    <Login />
  );
}
